// extracted by mini-css-extract-plugin
module.exports = {"main":"BackButton_main__1lgRS","btnWrapper":"BackButton_btnWrapper___xtLg"};